module.exports = __webpack_public_path__ + "static/media/Defects.69ee5e15.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Defects.PNG
// module id = 2302
// module chunks = 0